import { Navbar } from "../shared/components/Navbar"
import { useLanguage } from "../shared/context/LanguageContext"
import { useEffect, useRef, useState } from "react"
import { ChevronDown, ChevronRight } from "lucide-react"

export function OurClient() {
  const { translation, isRTL } = useLanguage()
  
  const clients = [
    {filter: translation.clientCategories[0], logos:["pepsico-D7-CtGNu.webp", "mac.svg", "extra.svg"]},
    {filter: translation.clientCategories[1], logos:["extra.svg", "othaim.svg", "tamimi.svg", "shaker-group.svg", "bawan.svg", "budget.svg", "utec.svg", "aic-steel.svg", "baan.svg", "primary.webp", "sahtain.webp", "albassami.webp", "seitco.webp", "fiqrat.webp", "match.webp", "oak.webp", "ibrahim-alqurashi.webp"]},
    {filter: translation.clientCategories[2], logos:["kelloggs-Cwb-KMUc.webp", "orange.webp", "kfc-CE4mpx5u.webp", "pizza-hut-BHQvNduP.webp", "baskin-robbins-7o8mz43I.webp", "cinnabon-D5Pcd_Vq.webp", "kraft-heinz-B6j_XY4k.webp", "lipton-BpKbZl86.webp", "caterpillar-BawJWNd-.webp", "fedex-BaqlJyZl.webp", "aramex-d2aMJvmz.webp", "bmw-Bsjg5ToL.webp", "chevrolet-DDaII-hf.webp", "opel-zRh9ObFP.webp", "totalenergies-DTD76g5L.webp", "decathlon-GeiobdZK.webp", "akzonobel-BQrFIhJM.webp", "hero-wJtZIa1m.webp", "tropicana-wQbQLUx3.webp", "mac-Do7td75W.webp", "coldwell-banker-ebK6vU0N.webp", "americana-C4QvikSL.webp", "farm-frites-C0CBZt-A.webp", "halwani-bros-w9vPht8s.webp", "transcom-CATj5rTc.webp", "rsm-CtxC8GBz.webp"]},
    {filter: translation.clientCategories[3], logos:["axa-D_Hkf-Yc.webp", "elsewedy-EKq30qy2.webp", "elaraby-COM0QVKd.webp", "edita-DD4wO3TW.webp", "domty-D9n4PDx8.webp", "gig-egypt-BC8lySy2.webp", "suez-canal-insurance-BmaFsMlI.webp", "beltone-financial-BMlpcO8_.webp"]},
    {filter: translation.clientCategories[4], logos:["egyptian-customs-DVArDcz7.webp", "alexandria-port-CQhi65Vh.webp", "alexandria-water-DGWZn-PG.webp", "egyptian-red-crescent-B6F-NJ0r.webp", "bibliotheca-alexandrina-Dx-iYNuY.webp", "misr-elkheir-aTgJ35We.webp", "alexandria-businessmen-vh5Msdyd.webp", "egypt-post.webp"]},
    {filter: translation.clientCategories[5], logos:["lafarge-3Ge2lNYf.webp", "suez-cement-mBE_U6sc.webp", "misr-cement-BcjfzR7z.webp", "petrojet-Pc_XeRz9.webp", "petromaint-BuVD196q.webp", "sidpec-Bd9YJlwk.webp", "ethydco-tq90jJva.webp", "el-marakby-steel-CkUpZtbN.webp", "canal-sugar-l4U5s2Z9.webp", "nile-sugar-DxPlr1HT.webp", "butagasco-CQOuMYwy.webp", "emc-X9hhBOid.webp", "taghleef-DP-0uPgp.webp", "alunile-DUjAMU9E.webp", "anrpc-8n08rmz8.webp", "mido-coatings-CfPz6mcu.webp", "concrete-COidjN61.webp", "karmsolar-BfpTh0lX.webp", "kima-DL7LuNj3.webp", "sprea-misr-D6s-rCva.webp", "nouval-electronics.webp", "kiriazi.webp", "damfi.webp", "alsharkiya-sugar.webp"]},
    {filter: translation.clientCategories[6], logos:["beyti-5NtelSis.webp", "aujan-cocacola-eeJAIsQa.webp", "vitrac-BTzjpiAa.webp", "regina-BhIyVbLP.webp", "evyap-ChReh-sF.webp", "gourmet-sJ3bXL69.webp", "wadi-food-rmo9PsqZ.webp", "egyptian-swiss-BhpOLgVc.webp", "al-safwa-hospital-CSVuPnkm.webp", "andalusia-hospitals-jq0AxUAL.webp", "magrabi-D83YSPma.webp", "seha-healthcare-D4Jvf8zB.webp", "medright-BXSIqzH1.webp", "onehealth-Ce-dswdS.webp", "trust-labs-D6ZqWZ6v.webp", "nsa-labs-CWIoCSPJ.webp", "macro-pharma-NY2mcuUm.webp", "kandil-zcm7sp0I.webp", "el-senouki-6EgDKfvT.webp", "tank-DWHTtXA9.webp", "senyorita-CYusZ40D.webp", "sea-harvest-D5NUtxaH.webp", "all-foods-DPGkpQm-.webp", "royal-herbs-DMcEHppo.webp", "raya-foods-DEt1E6ae.webp", "adwia-BA6E2--f.webp", "sofico-pharm-CvTmAyFr.webp", "integrated-cosmetic-D4_ssqh5.webp", "yolo-cosmetics-Cx2xWaiI.webp", "minlo-DgqN-AAf.webp", "tay-group.webp", "misr-pharma.webp", "cleopatra.webp", "vitabiotics-Dk46D8vY.webp", "arab-caps-DVl2PA1A.webp"]},
    {filter: translation.clientCategories[7], logos:["nile-air-Dd1S39rU.webp", "egytrans-m_X_LBiJ.webp", "option-travel-siLZapI2.webp"]},
    {filter: translation.clientCategories[8], logos:["mountain-view-C0v1e8eQ.webp", "sodic-DZri1kAe.webp", "ora-CnnpXbjM.webp", "madinet-nasr-BRHJOB1Y.webp", "madinet-masr-pm-CAoSZOk-.webp", "somabay-BIKVDi5G.webp", "wadi-degla-Cf03EtDJ.webp", "tabarak-KalQedIz.webp", "marseilia-v1JaoX3N.webp", "el-nasr-housing-BismjxrO.webp", "imkan-misr.webp", "nouval-BXT3iPSS.webp", "hesni-DQgX48Vs.webp", "apleona-hA3RKPhM.webp", "egypro-fme-Ccl3qx4_.webp"]},
    {filter: translation.clientCategories[9], logos:["zahran-market-CmvLqrRw.webp", "dalydress-BGP8ifVu.webp", "mazaya-DBA_fToC.webp", "nadim-B4lvypZJ.webp", "meg-BcRGjly3.webp", "salam-altawleed-sEx5v4ud.webp", "eaco-DScbi2B4.webp", "reserval-BDD4KHTe.webp", "tbs.webp"]},
    {filter: translation.clientCategories[10], logos:["mansour-zPThIrzA.webp", "mantrac-3IJ9sWCt.webp", "raya-2yP4Fu2h.webp", "ufe-DBydHP1q.webp", "alsafy-group-Blkfeq2p.webp", "triangle-group-C76Fq-M8.webp"]},
    {filter: translation.clientCategories[11], logos:["trella.webp", "swvl-Dj0s6lz9.webp", "vezeeta-CvO3d02i.webp", "instabug-CbiHsNG3.webp", "wuzzuf-Cghc-VQx.webp", "itworx-BzPCoNro.webp", "elmenus-x50IwqA-.webp", "homzmart-DN38joD5.webp", "maxab-BDrDS3PM.webp", "cartona-S-jtZEGd.webp", "brimore-Manc5teH.webp", "capiter-BDv7MdtM.webp", "mrsool-OkF8wxEa.webp", "waffarha-BJC_7evB.webp", "bee-8nxdczFf.webp", "milezmore-BE8lx0uj.webp", "sequenes.webp", "ta-telecom-Futkx9jJ.webp", "raya-it-DgyIF_8E.webp", "raya-electric-Cl-p3Ji1.webp", "raya-cx-8ESTedtM.webp", "giza-systems-Bl3-6mx4.webp", "ibs-GMHFvyLa.webp", "majorel-87YrGhiu.webp", "icall-ZWam0_AF.webp", "wasla-outsourcing-DKxqi4UN.webp", "top-business-BPJsqMP5.webp", "partner-peo-DK7ZMwKG.webp", "arab-academy-DkbPtW2X.webp", "el-alsson-B9Ku2gDC.webp", "misr-language-schools-Df9UN457.webp", "gems-education-Qp7n9Tat.webp", "family-Cw7t133_.webp", "audio-technology-Vob031m7.webp", "bavarian-auto-8cjE5IhP.webp", "abco.webp", "centro-global-nRGb9ugz.webp", "sts-BsCzMsAY.webp", "speed-l-N44njs.webp", "sky-DCYRkotK.webp", "tiba-2000-BMPbTCUX.webp", "steigenberger.webp", "bosta.webp", "natco1.webp", "natco2.webp", "natco3.webp"]},
  ]
  const [open, setOpen] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState(translation.clientCategories[0])
  const clientCategories = "clientCategories" in translation ? translation.clientCategories : []
  const prevCategoriesRef = useRef<string[]>(clientCategories)
  const selectedCategoryIndex = clientCategories.indexOf(selectedCategory)
  const selectedClients =
    selectedCategoryIndex >= 0 && selectedCategoryIndex < clients.length
      ? clients[selectedCategoryIndex]
      : clients[0]
  const insertLogoAfter = (logos: string[], afterLogo: string, logoToInsert: string) => {
    if (logos.includes(logoToInsert)) return logos
    const insertIndex = logos.indexOf(afterLogo)
    if (insertIndex === -1) return [...logos, logoToInsert]
    const updatedLogos = [...logos]
    updatedLogos.splice(insertIndex + 1, 0, logoToInsert)
    return updatedLogos
  }

  const allClientLogos = clients
    .filter((_, index) => index !== 0)
    .flatMap((client) => client.logos)
  const featuredLogos = clients[0]?.logos ?? []
  const displayedLogos =
    selectedCategoryIndex === 0
      ? [...featuredLogos, ...allClientLogos.filter((logo) => !featuredLogos.includes(logo))]
      : selectedCategoryIndex === 2
        ? insertLogoAfter(
            insertLogoAfter(selectedClients.logos, "kelloggs-Cwb-KMUc.webp", "mac.svg"),
            "orange.webp",
            "pepsico-D7-CtGNu.webp"
          )
        : selectedClients.logos

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" })
  }, [selectedCategory])

  useEffect(() => {
    if (clientCategories.length === 0) {
      return
    }
    if (clientCategories.includes(selectedCategory)) {
      prevCategoriesRef.current = clientCategories
      return
    }
    const prevIndex = prevCategoriesRef.current.indexOf(selectedCategory)
    const nextCategory = prevIndex >= 0 ? clientCategories[prevIndex] : clientCategories[0]
    if (nextCategory && nextCategory !== selectedCategory) {
      setSelectedCategory(nextCategory)
    }
    prevCategoriesRef.current = clientCategories
  }, [clientCategories, selectedCategory])

  const selectCategory = (category: string) => {
    setSelectedCategory(category)
    setOpen(false)
  }

  return (
    <main>
      <div className="sticky top-5 sm:top-0 md:relative z-50 mx-5 md:mx-7 lg:mx-10 xl:mx-[3.125rem] bg-secondary rounded-3xl">
        <Navbar />
      </div>
      <div className="flex flex-col gap-5 px-5 md:gap-9 md:py-9 md:px-9 lg:flex-row lg:gap-20 lg:py-0 lg:pt-[4.375rem] lg:px-[5.625rem]">
        <div className="flex flex-col gap-4 lg:gap-[1.875rem] m-w-fit lg:w-[18rem] xl:w-[21rem] px-5 pt-9 lg:px-0 lg:pt-0">
          <h2 className="text-[1.75rem] md:text-3xl lg:text-4xl xl:text-[2.5rem] font-bold text-primary">{translation.ourClients}</h2>
          <section>
            {/* Mobile */}
            <div className="block lg:hidden">
              <button
                onClick={() => setOpen(!open)}
                className="w-full flex items-center justify-between py-2.5 my-2.5 border-y border-dashed border-softGreen text-left text-base md:text-xl"
              >
                <span className={"text-primary font-bold"}>{selectedCategory}</span>
                <ChevronDown
                  className={`w-5 h-5 text-primary transition-transform ${open ? "rotate-180" : ""}`}
                />
              </button>
              {open && (
                <ul className="space-y-2.5">
                  {clientCategories.map((item: string, index: number) => (
                    <li
                      key={item}
                      className={`text-base md:text-xl text-primary hover:text-hoverColor cursor-pointer ${index === clientCategories.length - 1 ? "border-b border-dashed border-softGreen pb-2.5" : ""}`}
                      onClick={() => selectCategory(item)}
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            {/* Desktop */}
            <ul className="hidden lg:block space-y-[0.625rem]">
              {clientCategories.map((item: string) => (
                <li
                  key={item}
                  className="flex items-center justify-between border-t border-dashed border-softGreen pt-2 cursor-pointer hover:text-hoverColor"
                  onClick={() => selectCategory(item)}
                >
                  <span className={`text-primary lg:text-xl xl:text-[1.375rem] ${selectedCategory === item ? "font-bold" : ""}`}>{item}</span>
                  {selectedCategory === item && <ChevronRight size={24} color="#004E64" className={`hover:text-hoverColor transition-colors ${isRTL ? "rotate-180" : ""}`} />}
                </li>
              ))}
            </ul>
          </section>
        </div>
        <div className="w-full lg:w-2/3 flex md:justify-center items-start">
            <div
              className="w-full grid grid-cols-2 md:grid-cols-3 gap-x-5 gap-y-6 md:gap-7 lg:gap-12 xl:gap-[3.75rem]"
              dir={isRTL ? "rtl" : "ltr"}
            >
            {displayedLogos.map((client, index) => (
              <div key={index} className="flex items-center justify-center">
                <img
                  src={`/logos/clients/${client}`}
                  alt={client}
                  className="w-[7rem] h-[3.75rem] lg:w-[12rem] lg:h-[4.5rem] xl:w-[15rem] xl:maxh-[6.625rem] object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  )
}

